exports.generic = require('./schemas/generic')
exports.mongoose = require('./schemas/mongoose')
exports.bigquery = require('./schemas/bigquery')
exports.mysql = require('./schemas/mysql')
exports.json = require('./schemas/json')
exports.clickhouse = require('./schemas/clickhouse')



//////////////////
// WEBPACK FOOTER
// ./~/generate-schema/src/index.js
// module id = 523
// module chunks = 0